import { FC, SVGProps } from 'react'

import canadaFlag from '@src/components/icons/canada.inline.svg'
import usaFlag from '@src/components/icons/usa.inline.svg'
import { TCountry } from '@src/config/i18n.config'

export const COUNTRY_CONFIG: Record<TCountry, { flag: FC<SVGProps<SVGElement>> }> = {
  us: {
    flag: usaFlag,
  },
  ca: {
    flag: canadaFlag,
  },
}

export const LOCALE_STANDARD_FORMAT = 'en-US'
export const LOCALE_STANDARD_FORMAT_CANADA = 'en-CA'
export const LOCALE_STANDARD_FORMAT_CANADA_FRENCH = 'fr-CA'

export const KLARNA_REGION_WISE_CLIENT_ID_CONFIG = {
  us: 'b422da9d-78be-55a0-a693-7d1c18ca1b82',
  ca: 'de6c249a-249b-548b-80e8-ff6a227f8957',
}

export const I18N_PREVIEW_KEY = 'enableQuinceCanada'
export const I18N_PREVIEW_TTL_MINUTES = 30 * 24 * 60 // 30 days
export const IS_LOCALISATION_ENABLED_FOR_COUNTRY_KEY = 'enableUSAExperiment'
export const USA_LOCALISATION_TTL_MINUTES = 30 * 24 * 60 // 30 days
